import React from 'react';
import { useNavigate } from 'react-router-dom'; // Using useNavigate for navigation
import Navbar from '../components/Navbar'; // Adjust the path as needed
import '../styles/CAD.css';

const ConversationalAIChatbotDevelopment = () => {
    const navigate = useNavigate();

    // For demonstration, all buttons navigate to google.com; replace with actual paths as needed.
    const handleNavigation = () => {
        navigate('/contact');
    };

    return (
        <>
            <Navbar />
            <div className="custom-app-development">
                <div className="content-box">
                    <header className="header">
                        <h1>Conversational AI Chatbot Development</h1>
                        <p className="tagline">
                            Transform customer interactions with next-generation chatbots
                        </p>
                    </header>
                    
                    <section className="introduction">
                        <p>
                        In today's digital world, the ability to offer instantaneous personal support is synonymous with customer satisfaction; so the Conversational AI Chatbot Development service uses solutions powered by advanced natural language processing and machine learning to build intelligent chatbots that converse, assist, and convert them 24/7.
                        </p>
                    </section>
                    
                    <section className="why-choose-us">
                        <h2>Why Choose Us?</h2>
                        <p>
                        Our chatbots provide natural context-based conversations deeply integrated with your systems. Your chatbot gets smarter with continuous learning and analytics according to your business needs-it'll be secure, scalable, and compliant with privacy norms.
                        </p>
                    </section>
                    
                    <section className="tech-stack">
                        <h2>Our Technology Stack</h2>
                        <p>
                        We build chatbots using state-of-the-art frameworks and platforms.
                        </p>
                        <ul>
                            <li><strong>NLP Frameworks:</strong> Dialogflow, IBM Watson, Microsoft Bot Framework</li>
                            <li><strong>Machine Learning:</strong> TensorFlow, PyTorch for continuous improvement</li>
                            <li><strong>Cloud Infrastructure:</strong> Scalable solutions on AWS, Azure, or Google Cloud</li>
                            <li><strong>Analytics & Integration:</strong> Seamless integration with CRM, ERP, and other business systems</li>
                        </ul>
                    </section>
                    
                    <section className="secure-practices">
                        <h2>Secure Coding Practices</h2>
                        <p>
                        Data privacy and secure communication are of high importance; standing at the top of our industry best practices stand security audits and encryption standards to keep your customers' data protected in every interaction.
                        </p>
                    </section>
                    
                    <section className="services">
                        <h2>Our Services</h2>
                        <div className="service-container">
                            <div className="service-box">
                                <h3>Customer Support Chatbots</h3>
                                <p>
                                    Enhance customer service with 24/7 automated support and instant query resolution.
                                </p>
                                <button className="learn-more" onClick={handleNavigation}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Sales & Marketing Chatbots</h3>
                                <p>
                                    Engage prospects with personalized recommendations, promotions, and lead generation.
                                </p>
                                <button className="learn-more" onClick={handleNavigation}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Internal Automation Chatbots</h3>
                                <p>
                                    Streamline employee workflows with chatbots that support internal helpdesk and process automation.
                                </p>
                                <button className="learn-more" onClick={handleNavigation}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Voice-Enabled Assistants</h3>
                                <p>
                                    Leverage voice recognition and natural conversation to create interactive, voice-activated assistants.
                                </p>
                                <button className="learn-more" onClick={handleNavigation}>
                                    Learn More
                                </button>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
};

export default ConversationalAIChatbotDevelopment;
